import { apiClient, handleResp } from './utils';
import { map } from 'lodash';
import { getVal } from '@/utils';

export default {
  getCategories() {
    return handleResp(apiClient().get('/categories'));
  },
  getCareCategories() {
    return handleResp(apiClient().get('/care_categories'));
  },
  buildCategory(cateList) {
    return map(cateList, cate => ({
      ...cate,
      en: {
        name: cate.name,
        description: cate.description,
      },
      es: {
        name: getVal(cate, 'name_es', cate.name),
        description: getVal(cate, 'description_es', cate.description),
      },
      answers: map(cate.answers, answer => ({
        ...answer,
        en: {
          title: answer.title,
          transcript: answer.transcript,
          description: answer.description,
          playerembed: answer.playerembed,
        },
        es: {
          title: getVal(answer, 'title_es', answer.title),
          transcript: getVal(answer, 'transcript_es', answer.transcript),
          description: getVal(answer, 'description_es', answer.description),
          playerembed: getVal(answer, 'playermebed_es', answer.playerembed),
        },
      })),
    }));
  },
};
